/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecutedBondTrade
 */
export interface ExecutedBondTrade {
    /**
     * 
     * @type {string}
     * @memberof ExecutedBondTrade
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutedBondTrade
     */
    side: string;
}

/**
 * Check if a given object implements the ExecutedBondTrade interface.
 */
export function instanceOfExecutedBondTrade(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "side" in value;

    return isInstance;
}

export function ExecutedBondTradeFromJSON(json: any): ExecutedBondTrade {
    return ExecutedBondTradeFromJSONTyped(json, false);
}

export function ExecutedBondTradeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutedBondTrade {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbol': json['symbol'],
        'side': json['side'],
    };
}

export function ExecutedBondTradeToJSON(value?: ExecutedBondTrade | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbol': value.symbol,
        'side': value.side,
    };
}

